MaxEpisodesWatchedModal;
import { StyleSheet, ImageBackground } from "react-native";
import React from "react";
import { Modal, VStack } from "native-base";
import { colors } from "../../../styles/GlobalStyle";
import { H2, Txt } from "../../TextsComponents";
import DimensionsHook from "../../../hooks/DimensionsHook";
import { useTranslation } from "react-i18next";
import { PrimaryButton } from "../../Buttons";

const MaxEpisodesWatchedModal = ({ isOpen, setIsOpen, navigation }) => {
  const { t } = useTranslation();
  const { isMobile } = DimensionsHook();
  const closeHandler = () => {
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={closeHandler}>
      <Modal.Content style={styles.container}>
        <Modal.Body>
          <ImageBackground
            source={require("../../../assets/background.png")}
            style={{ flex: 1 }}
          >
            <Modal.CloseButton
              focusable={false}
              style={{ marginRight: isMobile ? 0 : 10 }}
            />
            <VStack
              justifyContent="center"
              alignItems="center"
              style={{ marginTop: 40 }}
            >
              <H2
                style={{
                  textAlign: "center",
                  lineHeight: isMobile ? 32 : 40,
                  marginHorizontal: 20,
                }}
              >
                {t("max_episodes_modal.title")}
              </H2>

              <Txt
                style={{
                  marginTop: 30,
                  textAlign: "center",
                  marginHorizontal: 20,
                }}
              >
                {t("max_episodes_modal.text1")}
              </Txt>
              <Txt
                style={{
                  marginTop: 15,
                  textAlign: "center",
                  marginHorizontal: 20,
                }}
              >
                {t("max_episodes_modal.text2")}
              </Txt>

              <PrimaryButton
                onPress={() => {
                  closeHandler();
                  navigation.goBack();
                }}
                style={{ marginVertical: 30 }}
              >
                {t("max_episodes_modal.button")}
              </PrimaryButton>
            </VStack>
          </ImageBackground>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

export default MaxEpisodesWatchedModal;

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.white,
    width: "95%",
    maxWidth: 1000,
    maxHeight: 5000,
  },
});
